import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { StationSelectionIdentity } from '../model/StationSelectionIdentity';
import { Observable } from 'rxjs';
import { StationGroup } from '../model/StationGroup';

@Injectable({
  providedIn: 'root'
})
export class StationSelectionService {

  constructor(private appServerAPI: AppServerAPI) { }

  getStationStructureDefinition(entity: StationSelectionIdentity): Observable<StationGroup[]> {
    return this.appServerAPI.execute<StationGroup[]>(`/client/control/stationselection/structure`, entity);
  }
}
